import { isExternalLink, isValidUrl } from '@dc-shared-web/lib/utils'

const HIGHLIGHT_SEARCH_PARAM = 'highlight'
const PAGE_SEARCH_PARAM = 'page'
const PROVISION_SEARCH_PARAM = 'provision'

const createUrl = (
  page: number,
  highlight: string | undefined,
  searchParams: URLSearchParams,
  pathname: string
) => {
  const newSearchParams = new URLSearchParams(searchParams)

  newSearchParams.set(PAGE_SEARCH_PARAM, page.toString())

  if (highlight) {
    newSearchParams.set(HIGHLIGHT_SEARCH_PARAM, highlight)
    newSearchParams.delete(PROVISION_SEARCH_PARAM)
  } else {
    newSearchParams.delete(HIGHLIGHT_SEARCH_PARAM)
  }

  return `${pathname}?${newSearchParams.toString()}`
}

const cleanUrl = (url: string): string => {
  return url.replace(/(?:%26|&amp;|amp%3B)/g, '&')
}

export const AITextLinkGeneric = ({
  page,
  highlight,
  children,
  baseUrl,
}: {
  page: number | string
  highlight?: string
  children: React.ReactNode
  baseUrl?: string
}) => {
  const location = window.location
  const searchParams = new URLSearchParams(location.search)

  let rawUrl = ''

  if (isValidUrl(String(page))) {
    rawUrl = String(page)
  } else if (!isNaN(parseInt(page as string))) {
    rawUrl = createUrl(
      parseInt(page as string),
      highlight,
      searchParams,
      baseUrl || location.pathname
    )
  } else {
    return <span className='tw-contents'>{children}</span>
  }

  const url = cleanUrl(rawUrl)
  const isExternal = isExternalLink(url)
  const displayText = `(Page ${page})`

  return (
    <a
      className='tw-text-blue-600 hover:tw-cursor-pointer hover:tw-underline tw-contents'
      data-testid='page-link'
      data-managed
      href={url}
      {...(isExternal && {
        target: '_blank',
        rel: 'noopener noreferrer',
      })}
    >
      <span className='tw-contents'>{displayText}</span>
    </a>
  )
}
